import { render } from "./App.vue?vue&type=template&id=5778e3dc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5778e3dc&lang=scss"

import exportComponent from "/home/jamin/Ideas/wedding/website4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__